import { Reveal } from "./Reveal";
import { Unplug, Feather, Anchor } from "lucide-react";

const weeks = [
  {
    n: "Semaine 1",
    icon: Unplug,
    title: "Déconnecter",
    desc: "On coupe en douceur avec les écrans et l’agitation mentale. Premiers exercices de respiration pour ralentir le soir.",
    points: ["Couvre-feu digital", "Respiration 4-7-8", "Rituel de fin de journée"],
  },
  {
    n: "Semaine 2",
    icon: Feather,
    title: "Relâcher",
    desc: "Le corps apprend à lâcher les tensions. Relaxation musculaire, visualisations et premières relaxations audio guidées.",
    points: ["Relaxation musculaire", "Visualisations", "Ambiances sonores"],
  },
  {
    n: "Semaine 3",
    icon: Anchor,
    title: "Ma routine",
    desc: "On ancre les habitudes qui durent. Ta routine du soir devient naturelle, personnelle et facile à tenir.",
    points: ["Routine sur-mesure", "Journal du sommeil", "SOS réveil nocturne"],
  },
];

export const Program = () => {
  return (
    <section
      id="program"
      data-testid="program-section"
      className="relative mx-auto max-w-6xl scroll-mt-24 px-6 py-24 md:py-32 lg:px-10"
    >
      <Reveal className="mb-16 text-center">
        <p className="mb-5 text-xs font-semibold uppercase tracking-[0.3em] text-[#c9a84c]">
          21 nuits · 3 semaines
        </p>
        <h2 className="mx-auto max-w-2xl text-4xl font-light leading-tight tracking-tight sm:text-5xl">
          Un chemin progressif vers le calme
        </h2>
      </Reveal>

      <div className="grid gap-6 md:grid-cols-3">
        {weeks.map((w, i) => (
          <Reveal
            key={w.n}
            delay={i * 0.12}
            className="card-line flex flex-col rounded-2xl border border-white/8 bg-[#1e1535] p-8"
          >
            <div className="flex items-center justify-between">
              <span className="text-xs uppercase tracking-[0.25em] text-white/40">
                {w.n}
              </span>
              <div className="flex h-11 w-11 items-center justify-center rounded-full border border-[#c9a84c]/25 bg-[#0a0e1a]">
                <w.icon className="h-5 w-5 text-[#e8c97a]" strokeWidth={1.5} />
              </div>
            </div>
            <h3 className="mt-8 text-2xl font-medium tracking-tight text-white">
              {w.title}
            </h3>
            <p className="mt-4 flex-1 text-sm leading-relaxed text-white/55">
              {w.desc}
            </p>
            <ul className="mt-7 space-y-2.5 border-t border-white/8 pt-6">
              {w.points.map((p) => (
                <li key={p} className="flex items-center gap-3 text-sm text-white/70">
                  <span className="h-1 w-1 rounded-full bg-[#c9a84c]" />
                  {p}
                </li>
              ))}
            </ul>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
